import React from "react";
import { motion } from "framer-motion";

export default function ContactLottie() {
  return (
    <section id="contact" className="relative py-20 bg-slate-900">
      <div className="absolute inset-0 overflow-hidden">
        <motion.div
          className="absolute -top-10 -left-10 w-60 h-60 rounded-full bg-blue-600/20"
          animate={{ y: [0, 20, 0], x: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 8 }}
        />
        <motion.div
          className="absolute bottom-10 right-10 w-72 h-72 rounded-3xl bg-purple-600/20"
          animate={{ y: [0, -15, 0], x: [0, -10, 0] }}
          transition={{ repeat: Infinity, duration: 10 }}
        />
      </div>
      <div className="container relative z-10 mx-auto px-6 max-w-3xl">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-8">
          Get in Touch
        </h2>
        <div className="glass rounded-2xl p-6 mb-6 text-center text-gray-200">
          {/* Placeholder for Lottie animation (add JSON later) */}
          <div className="w-full h-40 bg-white/10 rounded-lg" />
        </div>
        <form className="glass rounded-2xl p-6 space-y-4">
          <input
            className="w-full rounded-lg bg-transparent border border-white/20 px-4 py-3 text-white placeholder-gray-300 focus:outline-none focus:border-blue-400"
            placeholder="Your Name"
          />
          <input
            type="email"
            className="w-full rounded-lg bg-transparent border border-white/20 px-4 py-3 text-white placeholder-gray-300 focus:outline-none focus:border-blue-400"
            placeholder="Email"
          />
          <textarea
            className="w-full rounded-lg bg-transparent border border-white/20 px-4 py-3 text-white placeholder-gray-300 focus:outline-none focus:border-blue-400"
            rows="5"
            placeholder="Message"
          />
          <button className="bg-blue-600 hover:bg-blue-500 text-white font-semibold px-6 py-3 rounded-xl transition">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
}
